export default __webpack_public_path__ + "static/media/57.963402c2.jpeg";